export default function isMale(genotype) {
  return !genotype.X.b
}